import FullWidthBarBreadcrumbs from '@/components/Breadcrumb/FullWidthBarBreadcrumbs';
import CenteredContentSection from '@/components/ContentSection/CenteredContentSection';
import DescirptionContainer from '@/components/DescriptionList/DescriptionContainer';
import DescriptionRow from '@/components/DescriptionList/DescriptionRow';
import { H3 } from '@/components/Element/Heading';
import VerticalLeadFormSection from '@/components/LeadForm/VerticalLeadFormSection';
import ListableList from '@/components/GridList/ListableList';
import MetaTags from '@/components/Head/MetaTags';
import { getManufacturerBySlug, getManufacturerInverters } from 'data/database';
import { Inverter, Manufacturer } from 'data/types';
import { OrganizationJsonLd } from 'next-seo';
import CompanyHeaderSection from '@/components/StateHeaderSection/CompanyHeaderSection';
import MessageBox from '@/components/MessageBox/MessageBox';

export async function getStaticPaths() {
  // const manufacturers = await getInverterManufacturers();
  return {
    paths: [],
    // manufacturers.map((manufacturer) => ({
    //   params: { manufacturer_slug: manufacturer.slug },
    // })),
    fallback: 'blocking', // false or 'blocking'
  };
}

type StaticProps = {
  params: {
    manufacturer_slug: string;
  };
};

export async function getStaticProps({
  params: { manufacturer_slug },
}: StaticProps) {
  const manufacturer = await getManufacturerBySlug(manufacturer_slug);
  const inverters = await getManufacturerInverters(manufacturer_slug);
  return { props: { manufacturer, inverters } };
}

type Props = {
  manufacturer: Manufacturer;
  inverters: Array<Inverter>;
};

export default function Page({ manufacturer, inverters }: Props) {
  return (
    <article>
      <MetaTags
        title={`${manufacturer.name} Solar Inverter Manufacturer Guide`}
      />
      <OrganizationJsonLd
        type="Corporation"
        name={manufacturer.name}
        legalName={manufacturer.legalName}
        logo={manufacturer.webpPath}
        // address={manufacturer.address}
        url={`https://energypal.com/best-solar-inverters-for-homes/${manufacturer.slug}`}
      />

      <CompanyHeaderSection
        installer={manufacturer.name}
        imageUrl={manufacturer.webpPath}
        type="Solar Inverter Manufacturer"
        dark
      />
      <FullWidthBarBreadcrumbs
        pages={[
          {
            name: 'Resources',
            href: '/solar-customer-resources',
          },
          {
            name: 'Best Solar Inverters for Homes',
            href: '/best-solar-inverters-for-homes',
          },
          {
            name: manufacturer.name,
            href: `/best-solar-inverters-for-homes/${manufacturer.slug}`,
          },
        ]}
      />
      <CenteredContentSection>
        {manufacturer.slug == 'sunpower' && <MessageBox />}
        <DescirptionContainer>
          <DescriptionRow label="Name">{manufacturer.name}</DescriptionRow>
          <DescriptionRow label="Website">
            {manufacturer.website}
          </DescriptionRow>
          <DescriptionRow label="Address">
            {manufacturer.address}
          </DescriptionRow>
          <DescriptionRow label="About">{manufacturer.intro}</DescriptionRow>
        </DescirptionContainer>
        <H3>{manufacturer.name} Solar Inverters</H3>
        <ListableList
          listables={inverters}
          pathPrefix={`/best-solar-inverters-for-homes/${manufacturer.slug}`}
        />
      </CenteredContentSection>
      <VerticalLeadFormSection />
    </article>
  );
}
